module.exports = __webpack_public_path__ + "img/254e1d44b77b7f23ae744b48eb5e13fe.e8d97129.jpg";